import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const EnNoveltyLogoIcon = memo<ISvgProps>((props, { className }) => (
  <Svg
    className={className}
    id="en-novelty"
    xmlns="http://www.w3.org/2000/svg"
    width="240"
    height="72"
    viewBox="0 0 240 72"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={0.116}
        x2={0.852}
        y1={0.141}
        y2={0.858}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#00e4b9" />
        <stop offset={1} stopColor="#00afbf" />
      </linearGradient>
    </defs>
    <path fill="none" d="M0 0h240v72H0z" data-name="Rectangle 6045" />
    <g data-name="Group 17796">
      <path
        fill="url(#a)"
        d="M24 48a24.006 24.006 0 0 1-9.343-46.113 24.006 24.006 0 0 1 18.684 44.228A23.851 23.851 0 0 1 24 48Zm-8.893-20.656L9.953 29.3a15.018 15.018 0 0 0 28.1-.024l-5.158-1.943a9.506 9.506 0 0 1-17.786.014Z"
        data-name="Subtraction 1"
        transform="translate(3.339 15.999)"
      />
      <path
        fill="#191919"
        d="M80.549 53.068v-4.937h-9.611v-4.477h8.689v-4.575h-8.689v-4.443h9.578v-4.9H65.738v23.332Zm8.986-9.381a2.655 2.655 0 0 1 2.7-2.864 2.534 2.534 0 0 1 2.665 2.831v9.414h5V42.799c0-3.588-1.843-6.517-5.957-6.517a5.361 5.361 0 0 0-4.575 2.3v-1.868h-4.836v16.354h5Zm23.731 1.712V40.89h-9.876v4.509Zm24.291 7.669V29.732h-5.2v14.182l-8.756-14.182h-6.32v23.336h5.168V37.73l9.611 15.338Zm12.046-4.114c-1.876 0-3.686-1.349-3.686-4.081 0-2.765 1.81-4.048 3.686-4.048 1.909 0 3.686 1.284 3.686 4.048s-1.777 4.081-3.686 4.081Zm0-12.738a8.452 8.452 0 0 0-8.689 8.656 8.479 8.479 0 0 0 8.689 8.689 8.46 8.46 0 0 0 8.687-8.689 8.433 8.433 0 0 0-8.687-8.658Zm27.517.498h-5.266l-3.49 10.166-3.785-10.166h-5.431l6.714 16.358h5.036Zm5.826 6.221a3.116 3.116 0 0 1 3.259-2.765c2.37 0 3.226 1.514 3.291 2.765Zm6.911 4.241a3.16 3.16 0 0 1-3.291 2.138 3.541 3.541 0 0 1-3.719-3.16h11.388a10.441 10.441 0 0 0 .1-1.547c0-5.266-3.127-8.393-8.2-8.393a8.252 8.252 0 0 0-8.163 8.624 8.33 8.33 0 0 0 8.525 8.722c4.147 0 6.747-2.37 7.537-5.2Zm12.7 5.892v-23.83h-5v23.83Zm10.4-21.131h-4.467v2.107a2.4 2.4 0 0 1-2.538 2.67h-.823v4.378h2.9v7.006c0 3.259 2.074 5.266 5.464 5.266a5.952 5.952 0 0 0 2.6-.461v-4.147a6.17 6.17 0 0 1-1.317.165c-1.086 0-1.81-.362-1.81-1.712v-6.122h3.193v-4.373h-3.193Zm13.633 27.417 10.071-22.64h-5.3l-3.621 8.755-3.981-8.755h-5.6l6.879 14.153-3.719 8.492Z"
        data-name="Path 23972"
      />
    </g>
  </Svg>
));

EnNoveltyLogoIcon.displayName = 'EnNoveltyLogoIcon';

export default EnNoveltyLogoIcon;
